<!--******************************************************AUFTRAGSERFASSUNG******************************************************-->
<!------------------------------------------------------------KOPFZEILE------------------------------------------------------------>

<div class="cw-flex-row">
  <h2>{{ 'GENERAL.ORDEROVERVIEW' | translate }}</h2>

  <phscw-toolbar
    componentIdentifier="order-tracking"
    [componentConnection]="$any(this)"
    [buttonEditmode]="dataItem.editable"
    [buttonClose]="showClose">
  </phscw-toolbar>
  <!--@todo: EditMode definieren-->
</div>

<form #orderTrackingForm="ngForm" (ngSubmit)="clickSubmit()" (keydown.enter)="$event.preventDefault()">
  <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
  <!-- Content -->
  @if (!loading) {
    <div>
      @if (!loading) {
        <div class="cw-submodules">
          <div class="cw-submodule">
            <!-- Modul-Titel -->
            <h3>{{ 'SHARED.ORDERTRACKING.JOBDATA' | translate }}</h3>
            <div class="cw-horizontalline"></div>
            @if (datafieldsConfiguration.id.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.ORDERID' | translate }}"
                name="id"
                inputId="id"
                [(ngModel)]="dataItem.id"
                [required]="datafieldsConfiguration.id.required"
              [disabled]="datafieldsConfiguration.id.disabled"></phscw-input-text>
            }
            @if (datafieldsConfiguration.order_status.visible) {
              <phscw-input-select
                [editMode]="editMode"
                label="{{ 'GENERAL.STATUS' | translate }}"
                name="order_status"
                inputId="order_status"
                [(ngModel)]="dataItem.order_status"
                [listentries]="datafieldsConfiguration.order_status.cwListentries"
                [required]="datafieldsConfiguration.order_status.required"
              [disabled]="datafieldsConfiguration.order_status.disabled"></phscw-input-select>
            }
            @if (datafieldsConfiguration.order_type.visible) {
              <phscw-input-select
                [editMode]="editMode"
                label="{{ 'GENERAL.ORDERTYPE' | translate }}"
                name="order_type"
                inputId="order_type"
                [(ngModel)]="dataItem.order_type"
                [listentries]="datafieldsConfiguration.order_type.cwListentries"
                [required]="datafieldsConfiguration.order_type.required"
              [disabled]="datafieldsConfiguration.order_type.disabled"></phscw-input-select>
            }
            @if (datafieldsConfiguration.order_range.visible) {
              <phscw-input-select
                [editMode]="editMode"
                label="{{ 'GENERAL.ASSORTMENT' | translate }}"
                name="order_range"
                inputId="order_range"
                [(ngModel)]="dataItem.order_range"
                [listentries]="datafieldsConfiguration.order_range.cwListentries"
                [required]="datafieldsConfiguration.order_range.required"
              [disabled]="datafieldsConfiguration.order_range.disabled"></phscw-input-select>
            }
            @if (datafieldsConfiguration.employee.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'GENERAL.EMPLOYEE' | translate }}"
                name="employee"
                inputId="employee"
                [(ngModel)]="dataItem.employee_name"
                [required]="datafieldsConfiguration.employee.required"
              [disabled]="datafieldsConfiguration.employee.disabled"></phscw-input-text>
            }
            @if (
              datafieldsConfiguration.payment_condition.visible && !paymentConditionDependsOnCharacteristic
              ) {
              <phscw-input-select
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.PAYMENTCONDITION' | translate }}"
                name="payment_condition"
                inputId="payment_condition"
                [(ngModel)]="dataItem.payment_condition"
                [listentries]="datafieldsConfiguration.payment_condition.cwListentries"
                [required]="datafieldsConfiguration.payment_condition.required"
              [disabled]="datafieldsConfiguration.payment_condition.disabled"></phscw-input-select>
            }
            <!-- Alternative zur Zahlungsbedingungs-Auswahl, die evtl. Mittels eines best. Kennzeichens eingeschränkt wurde. -->
            @if (paymentConditionDependsOnCharacteristic) {
              <phscw-input-select
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.PAYMENTCONDITION' | translate }}"
                name="payment_condition"
                inputId="payment_condition_alt"
                [(ngModel)]="dataItem.payment_condition"
              [selectData]="paymentConditions"></phscw-input-select>
            }
          </div>
          <div class="cw-submodule">
            <h3 class="header-margin">{{ 'SHARED.ORDERTRACKING.ORDERDATA' | translate }}</h3>
            <div class="cw-horizontalline"></div>
            @if (datafieldsConfiguration.order_date.visible) {
              <phscw-input-date
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.ORDERDATE' | translate }}"
                name="order_date"
                inputId="order_date"
                [(ngModel)]="dataItem.order_date"
                [required]="datafieldsConfiguration.order_date.required"
              [disabled]="datafieldsConfiguration.order_date.disabled"></phscw-input-date>
            }
            @if (datafieldsConfiguration.order_address.visible) {
              <phscw-input-text
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.ORDERADDRESS' | translate }}"
                name="order_address"
                inputId="order_address"
                [(ngModel)]="dataItem.order_address"
                [required]="datafieldsConfiguration.order_address.required"
              [disabled]="datafieldsConfiguration.order_address.disabled"></phscw-input-text>
            }
          </div>
          <div class="cw-submodule">
            <h3 class="header-margin">{{ 'SHARED.ORDERTRACKING.DELIVERYDATA' | translate }}</h3>
            <div class="cw-horizontalline"></div>
            @if (datafieldsConfiguration.delivery_date.visible) {
              <phscw-input-date
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.DELIVERYDATE' | translate }}"
                name="delivery_date"
                inputId="delivery_date"
                [(ngModel)]="dataItem.delivery_date"
                [required]="datafieldsConfiguration.delivery_date.required"
                [disabled]="datafieldsConfiguration.delivery_date.disabled"
                [highlightedDays]="dataItem.specificDeliveryDays"
                [highlightDates]="highlightDates"
              [min]="dataItem.order_date"></phscw-input-date>
            }
            @if (datafieldsConfiguration.delivery_address.visible) {
              <phscw-input-autocomplete
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.DELIVERYADDRESS' | translate }}"
                name="delivery_address"
                inputId="delivery_address"
                [backendLink]="'InstitutionsOrders/searchAddressesForAutoComplete'"
                [myValue]="dataItem.delivery_address"
                (optionSelected)="dataItem.delivery_institution_id = $event"
                [required]="datafieldsConfiguration.delivery_address.required"
                [disabled]="datafieldsConfiguration.delivery_address.disabled">
              </phscw-input-autocomplete>
            }
            @if (datafieldsConfiguration.wholesaler_address.visible) {
              <phscw-input-autocomplete
                [editMode]="editMode"
                label="{{ 'SHARED.ORDERTRACKING.WHOLESALER' | translate }}"
                name="wholesaler_address"
                inputId="wholesaler_address"
                [backendLink]="'InstitutionsOrders/searchAddressesForAutoComplete'"
                [optionalRestrictions]="{type1: 72, wholesaler: true}"
                [myValue]="dataItem.wholesaler_address"
                (optionSelected)="dataItem.wholesaler_institution_id = $event"
                (deleteClicked)="dataItem.wholesaler_institution_id = null"
                [required]="datafieldsConfiguration.wholesaler_address.required"
                [disabled]="datafieldsConfiguration.wholesaler_address.disabled">
              </phscw-input-autocomplete>
            }
            @if (datafieldsConfiguration.delivery_note.visible) {
              <phscw-input-textarea
                [editMode]="editMode"
                class="cw-flex-row cw-input"
                label="{{ 'SHARED.ORDERTRACKING.DELIVERYNOTE' | translate }}"
                name="delivery_note"
                inputId="delivery_note"
                [(ngModel)]="dataItem.delivery_note"
                [required]="datafieldsConfiguration.delivery_note.required"
                [disabled]="datafieldsConfiguration.delivery_note.disabled"
                [maxlength]="datafieldsConfiguration.delivery_note.maxlength"
              [rows]="3"></phscw-input-textarea>
            }
            <!-- Lieferzeit von bis, Wann kann der Kunde die Lieferung empfangen -->
            <div class="cw-flex-row">
              @if (datafieldsConfiguration.delivery_time_from.visible) {
                <phscw-input-time
                  [editMode]="editMode"
                  label="{{ 'SHARED.ORDERTRACKING.DELIVERYTIMEFROM' | translate }}"
                  name="delivery_time_from"
                  inputId="delivery_time_from"
                  [(ngModel)]="dataItem.delivery_time_from"
                  [required]="datafieldsConfiguration.delivery_time_from.required"
                [disabled]="datafieldsConfiguration.delivery_time_from.disabled"></phscw-input-time>
              }
              @if (
                !editMode &&
                datafieldsConfiguration.delivery_time_from.visible &&
                datafieldsConfiguration.delivery_time_to.visible &&
                !(dataItem.delivery_time_from == null || dataItem.delivery_time_to == null)
                ) {
                <span
                  class="delivery-time-margin"
                  >-</span
                  >
                }
                @if (datafieldsConfiguration.delivery_time_to.visible) {
                  <phscw-input-time
                    class="delivery-time-margin"
                    [editMode]="editMode"
                    name="delivery_time_to"
                    inputId="delivery_time_to"
                    [(ngModel)]="dataItem.delivery_time_to"
                    [required]="datafieldsConfiguration.delivery_time_to.required"
                  [disabled]="datafieldsConfiguration.delivery_time_to.disabled"></phscw-input-time>
                }
              </div>
              <!-- Falls Lieferdaten zurück in CW gespielt werden kann es sinnvoll sein folgende Felder anzuzeigen -->
              <!-- Wirklicher Lieferzeitpunkt (Zusammengesetzt aus Datum und Zeit) -->
              <div class="cw-flex-row">
                @if (datafieldsConfiguration.delivery_time.visible) {
                  <phscw-input-date
                    [editMode]="editMode"
                    label="{{ 'SHARED.ORDERTRACKING.DELIVERYTIME' | translate }}"
                    name="delivery_time_date"
                    inputId="delivery_time_date"
                    [(ngModel)]="dataItem.delivery_time_date"
                    [required]="datafieldsConfiguration.delivery_time.required"
                  [disabled]="datafieldsConfiguration.delivery_time.disabled"></phscw-input-date>
                }
                @if (datafieldsConfiguration.delivery_time.visible) {
                  <phscw-input-time
                    class="time-margin"
                    [editMode]="editMode"
                    name="delivery_time_time"
                    inputId="delivery_time_time"
                    [(ngModel)]="dataItem.delivery_time_time"
                    [required]="datafieldsConfiguration.delivery_time.required"
                  [disabled]="datafieldsConfiguration.delivery_time.disabled"></phscw-input-time>
                }
              </div>
              <!-- Tracking-ID der Lieferung und Tracking-URL -->
              @if (datafieldsConfiguration.tracking_number.visible) {
                <phscw-input-text
                  [editMode]="editMode"
                  label="{{ 'SHARED.ORDERTRACKING.TRACKINGID' | translate }}"
                  name="tracking_number"
                  inputId="tracking_number"
                  [(ngModel)]="dataItem.tracking_number"
                  [required]="datafieldsConfiguration.tracking_number.required"
                [disabled]="datafieldsConfiguration.tracking_number.disabled"></phscw-input-text>
              }
              @if (datafieldsConfiguration.tracking_url.visible) {
                <phscw-input-text
                  [editMode]="editMode"
                  label="{{ 'SHARED.ORDERTRACKING.TRACKINGURL' | translate }}"
                  name="tracking_url"
                  inputId="tracking_url"
                  [(ngModel)]="dataItem.tracking_url"
                  valueDecorator="url"
                  [required]="datafieldsConfiguration.tracking_url.required"
                [disabled]="datafieldsConfiguration.tracking_url.disabled"></phscw-input-text>
              }
              <!-- Lieferkosten !Achtung: werden momentan nicht in der Order-Total-Berechnung beachtet!-->
              @if (datafieldsConfiguration.shipping_costs.visible) {
                <phscw-input-number
                  class="input-width"
                  [editMode]="editMode"
                  [customFormat]="customCurrencyFormat"
                  label="{{ 'SHARED.ORDERTRACKING.SHIPPINGCOSTS' | translate }}"
                  name="shipping_costs"
                  inputId="shipping_costs"
                  valueType="currency"
                  [currency]="currency"
                  [(ngModel)]="dataItem.shipping_costs"
                  [required]="datafieldsConfiguration.shipping_costs.required"
                [disabled]="datafieldsConfiguration.shipping_costs.disabled"></phscw-input-number>
              }
            </div>
            <div class="cw-submodule">
              <h3 class="header-margin">{{ 'SHARED.ORDERTRACKING.INVOICEDATA' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              <!-- Valuta Datum -->
              @if (datafieldsConfiguration.value_date.visible) {
                <phscw-input-date
                  [editMode]="editMode"
                  label="{{ 'SHARED.ORDERTRACKING.VALUEDATE' | translate }}"
                  name="value_date"
                  inputId="value_date"
                  [(ngModel)]="dataItem.value_date"
                  [required]="datafieldsConfiguration.value_date.required"
                [disabled]="datafieldsConfiguration.value_date.disabled"></phscw-input-date>
              }
              @if (datafieldsConfiguration.invoice_address.visible) {
                <phscw-input-autocomplete
                  [editMode]="editMode"
                  label="{{ 'SHARED.ORDERTRACKING.INVOICEADDRESS' | translate }}"
                  name="invoice_address"
                  inputId="invoice_address"
                  [backendLink]="'InstitutionsOrders/searchAddressesForAutoComplete'"
                  [myValue]="dataItem.invoice_address"
                  (optionSelected)="dataItem.invoice_institution_id = $event"
                  [required]="datafieldsConfiguration.invoice_address.required"
                  [disabled]="datafieldsConfiguration.invoice_address.disabled">
                </phscw-input-autocomplete>
              }
              @if (datafieldsConfiguration.invoice_note.visible) {
                <phscw-input-textarea
                  [editMode]="editMode"
                  class="cw-flex-row cw-input"
                  label="{{ 'SHARED.ORDERTRACKING.INVOICENOTE' | translate }}"
                  name="invoice_note"
                  inputId="invoice_note"
                  [(ngModel)]="dataItem.invoice_note"
                  [required]="datafieldsConfiguration.invoice_note.required"
                  [disabled]="datafieldsConfiguration.invoice_note.disabled"
                  [maxlength]="datafieldsConfiguration.invoice_note.maxlength"
                [rows]="3"></phscw-input-textarea>
              }
              @if (datafieldsConfiguration.purchase_order_number.visible) {
                <phscw-input-text
                  [editMode]="editMode"
                  label="{{ 'SHARED.ORDERTRACKING.PURCHASEORDERNUMBER' | translate }}"
                  name="purchase_order_number"
                  inputId="purchase_order_number"
                  [(ngModel)]="dataItem.purchase_order_number"
                  [required]="datafieldsConfiguration.purchase_order_number.required"
                [disabled]="datafieldsConfiguration.purchase_order_number.disabled"></phscw-input-text>
              }
              @if (datafieldsConfiguration.text.visible) {
                <phscw-input-textarea
                  [editMode]="editMode"
                  class="cw-flex-row cw-input"
                  label="{{ 'SHARED.ORDERTRACKING.NOTE' | translate }}"
                  name="text"
                  inputId="text"
                  [(ngModel)]="dataItem.text"
                  [required]="datafieldsConfiguration.text.required"
                  [disabled]="datafieldsConfiguration.text.disabled"
                [rows]="5"></phscw-input-textarea>
              }
            </div>
          </div>
        }
        <!-- Hinweis auf Pflichtfelder -->
        @if (editMode) {
          <div class="cw-horizontalline"></div>
        }
        @if (editMode) {
          <div>
            <span class="icon-asterisk cw-input-required-icon"></span>{{ 'GENERAL.REQUIREDFIELDS' | translate }}
          </div>
        }
        <!------------------------------------------------------------------Detailbereich-------------------------------------------------------------------------------------->
        <h3 class="extra-header-margin">{{ 'SHARED.ORDERTRACKING.ARTICLEORDER' | translate }}</h3>
        <div class="cw-horizontalline"></div>
        <!-- Grid für Artikelbestellung im Ansichtsmodus -->
        @if (!editMode && !(articleData | isUndefined)) {
          <div>
            <phscw-grid
              #gridInstitutionsOrderArticles
              gridId="institutionsOrderArticles"
              [simpleGrid]="true"
              [gridData]="$any(articleData)"
              [gridColumns]="articleGridColumns"
              [gridDisplayedColumns]="readonlyArticleGridDisplayedColumns">
            </phscw-grid>
          </div>
        }
        <!-- Edit-Table für editMode -->
        @if (editMode) {
          <div>
            <div [ngClass]="'cw-grid-container'">
              <mat-table #table [dataSource]="articleData">
                <!-- Sucht aktuell auch nach dem Produktkey, wenn dieser geladen, da es kein extra Feld dafür gibt. -->
                <ng-container matColumnDef="label">
                  <mat-header-cell *matHeaderCellDef class="cw-limit-cell-width">
                    {{ 'GENERAL.LABEL' | translate }}</mat-header-cell
                    >
                    <mat-cell *matCellDef="let element; let i = index" class="cw-limit-cell-width">
                      <phscw-input-autocomplete
                        [editMode]="editMode"
                        name="label"
                        [inputId]="'label' + i"
                        [backendLink]="'InstitutionsOrders/searchProductsForAutocomplete'"
                                [optionalRestrictions]="{
                                    institution_id: institutionId,
                                    order_range: dataItem.order_range,
                                    order_type: dataItem.order_type,
                                    search_column: articleSearchColumns
                                }"
                        [myValue]="element.label"
                        [optionalInfo]="i"
                        (optionSelected)="loadProductInformation($event)">
                      </phscw-input-autocomplete>
                    </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="pzn">
                    <mat-header-cell *matHeaderCellDef class="cw-set-width-cell">
                      {{ 'SHARED.ORDERTRACKING.PZN' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cw-set-width-cell">
                      {{ element.pzn }}
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                  </ng-container>
                  <ng-container matColumnDef="ean" style="max-width: 200px; width: 200px">
                    <mat-header-cell *matHeaderCellDef class="cw-set-width-cell" style="max-width: 200px; width: 200px">
                      {{ 'SHARED.ORDERTRACKING.EAN' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cw-set-width-cell" style="max-width: 200px; width: 200px">
                      {{ element.ean }}
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                  </ng-container>
                  <ng-container matColumnDef="delivery_address">
                    <mat-header-cell *matHeaderCellDef class="cw-set-width-cell"> Lieferaddresse</mat-header-cell>
                    <mat-cell *matCellDef="let element" class="cw-set-width-cell">
                      {{ element.delivery_address }}
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                  </ng-container>
                  <ng-container matColumnDef="order_item_delivery_date" style="width: 200px">
                    <mat-header-cell *matHeaderCellDef class="cw-set-width-cell"> Lieferdatum</mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index" class="cw-set-width-cell">
                      <phscw-input-date
                        [editMode]="editMode"
                        [name]="'order_item_delivery_date' + i"
                        [inputId]="'order_item_delivery_date' + i"
                      [(ngModel)]="element.delivery_date"></phscw-input-date>
                    </mat-cell>
                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                  </ng-container>
                  <ng-container matColumnDef="amount">
                    <mat-header-cell *matHeaderCellDef class="cw-set-width-cell">
                      {{ 'SHARED.ORDERTRACKING.QUANTITY' | translate }}</mat-header-cell
                      >
                      <mat-cell *matCellDef="let element; let i = index" class="cw-set-width-cell">
                        <phscw-input-number
                          name="amount"
                          [inputId]="'amount' + i"
                          [editMode]="editMode"
                          [mathValue]="element.amount"
                          [stepSize]="1"
                          [minValue]="1"
                                (input)="
                                    setSum(element, +$any($event.target).value); setTotalUnitPrice(element); setOrderTotal()
                                ">
                        </phscw-input-number>
                      </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="unit_price">
                      <mat-header-cell *matHeaderCellDef class="cw-set-width-cell">
                        {{ 'SHARED.ORDERTRACKING.UNITPRICE' | translate }}</mat-header-cell
                        >
                        <mat-cell *matCellDef="let element; let i = index" class="cw-set-width-cell">
                          <phscw-input-number
                            name="unit_price"
                            [inputId]="'unit_price' + i"
                            [valueType]="'currency'"
                            [currency]="currency"
                          [mathValue]="element.unit_price"></phscw-input-number>
                        </mat-cell>
                      </ng-container>
                      <ng-container matColumnDef="discount">
                        <mat-header-cell *matHeaderCellDef class="cw-set-width-cell">
                          {{ 'SHARED.ORDERTRACKING.DISCOUNT' | translate }}</mat-header-cell
                          >
                          <mat-cell *matCellDef="let element; let i = index" class="cw-set-width-cell">
                            <phscw-input-number
                                [ngClass]="{
                                    'percent-input-warning': element.discount > element.max_discount && version == 2
                                }"
                              name="discount"
                              [inputId]="'discount' + i"
                              [editMode]="editMode"
                              [valueType]="'percent'"
                              [maxValue]="100"
                              [minValue]="0"
                              [disabled]="exclusiveDiscounts && dataItem.order_discount != 0 ? true : false"
                              [mathValue]="element.discount"
                                (input)="
                                    element.discount = checkArticleDiscount($any($event.target).value);
                                    setTotalUnitPrice(element);
                                    checkIfAllPositionDiscountsAreEmpty()
                                "
                              (change)="setOrderTotal()">
                            </phscw-input-number>
                          </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="total_price">
                          <mat-header-cell *matHeaderCellDef class="cw-set-width-cell">
                            {{ 'SHARED.ORDERTRACKING.TOTALPRICE' | translate }}</mat-header-cell
                            >
                            <mat-cell *matCellDef="let element; let i = index" class="cw-set-width-cell">
                              <phscw-input-number
                                name="total_price"
                                [inputId]="'total_price' + i"
                                [valueType]="'currency'"
                                [currency]="currency"
                              [mathValue]="element.total_price"></phscw-input-number>
                            </mat-cell>
                            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                          </ng-container>
                          <!-- Empty Column, welche den restlichen Platz im Grid einnehmen kann, wenn bei alten anderen Spalten feste Breiten vorgegeben wurden -->
                          <ng-container matColumnDef="empty">
                            <mat-header-cell *matHeaderCellDef class="cw-limit-cell-width">&nbsp;</mat-header-cell>
                            <mat-cell *matCellDef="let element" class="cw-limit-cell-width">&nbsp;</mat-cell>
                          </ng-container>
                          <!--Zeile löschen-->
                          <ng-container matColumnDef="deleteColumn">
                            <mat-header-cell *matHeaderCellDef class="cw-limit-cell-width short"></mat-header-cell>
                            <mat-cell *matCellDef="let element; let rowID = index" class="cw-limit-cell-width short">
                              <button type="button" mat-icon-button small-icon-button focusable="false" (click)="deleteRow(rowID)">
                                <mat-icon>
                                  <fa-icon icon="ban"></fa-icon>
                                </mat-icon>
                              </button>
                            </mat-cell>
                          </ng-container>
                          <!--Header-Zeile-->
                          <mat-header-row *matHeaderRowDef="articleGridDisplayedColumns"></mat-header-row>
                          <!--Daten-Zeilen-->
                          <mat-row *matRowDef="let row; let tIndex = index; columns: articleGridDisplayedColumns"></mat-row>
                        </mat-table>
                        <!--Neue Zeile hinzufügen-->
                        @if (allowAddNewOrderItems) {
                          <button mat-icon-button medium-icon-button color="accent" type="button" (click)="addRow()">
                            <mat-icon>
                              <fa-icon icon="plus"></fa-icon>
                            </mat-icon>
                          </button>
                        }
                        @if (showErrorMessage) {
                          <div>
                            <span class="icon-asterisk cw-input-required-icon"></span>
                            {{ 'SHARED.ORDERTRACKING.SELECTIONNOTICE' | translate }}
                          </div>
                        }
                      </div>
                    </div>
                  }
                  <!-----------------------------------------------------------------Formular 3
                  Fußzeile-------------------------------------------------------------------------------------->
                  <h3 class="header-margin">{{ 'SHARED.ORDERTRACKING.ORDERSUM' | translate }}</h3>
                  <div class="cw-horizontalline"></div>
                  <div class="header-margin" [class]="editMode ? '' : 'cw-order-price-summary'">
                    @if (datafieldsConfiguration.order_articlesum.visible) {
                      <phscw-input-number
                        class="cw-order-price-summary-2"
                        [editMode]="editMode"
                        label="{{ 'SHARED.ORDERTRACKING.ARTICLESUM' | translate }}"
                        name="order_articlesum"
                        inputId="order_articlesum"
                        [(ngModel)]="articlesSum"
                        [disabled]="datafieldsConfiguration.order_articlesum.disabled"
                        #order_articlesum="ngModel"
                        [showAlternativeStyle]="editMode ? true : false"
                        (ngModelChange)="setOrderTotal()">
                      </phscw-input-number>
                    }
                    @if (datafieldsConfiguration.order_total_before_discount.visible) {
                      <phscw-input-number
                        [editMode]="editMode"
                        label="{{ 'SHARED.ORDERTRACKING.AEP' | translate }}"
                        name="order_total_before_discount"
                        inputId="order_total_before_discount"
                        [valueType]="'currency'"
                        [currency]="currency"
                        [(ngModel)]="dataItem.order_total_before_discount"
                        [disabled]="datafieldsConfiguration.order_total_before_discount.disabled"
                        #order_total_before_discount="ngModel"
                        (ngModelChange)="setOrderTotal()"
                        [showAlternativeStyle]="editMode ? true : false">
                      </phscw-input-number>
                    }
                    @if (datafieldsConfiguration.order_discount_text.visible) {
                      <phscw-input-text
                        [editMode]="editMode"
                        label="{{ 'SHARED.ORDERTRACKING.DISCOUNTTEXT' | translate }}"
                        name="order_discount_text"
                        inputId="order_discount_text"
                        [(ngModel)]="dataItem.order_discount_text"
                        [disabled]="datafieldsConfiguration.order_discount_text.disabled"
                        #order_discount_text="ngModel">
                      </phscw-input-text>
                    }
                    @if (datafieldsConfiguration.order_sum.visible) {
                      <phscw-input-number
                        [editMode]="editMode"
                        label="{{ 'SHARED.ORDERTRACKING.INTERMEDIATETOTAL' | translate }}"
                        name="order_sum"
                        inputId="order_sum"
                        [valueType]="'currency'"
                        [currency]="currency"
                        [(ngModel)]="dataItem.order_sum"
                        [disabled]="datafieldsConfiguration.order_sum.disabled"
                        #order_sum="ngModel"
                        [error]="order_sum.errors"
                        (ngModelChange)="setOrderTotal()"
                        [showAlternativeStyle]="editMode ? true : false">
                      </phscw-input-number>
                    }
                    @if (datafieldsConfiguration.order_discount.visible) {
                      <phscw-input-number
                        [editMode]="editMode"
                        label="{{ 'SHARED.ORDERTRACKING.INVOICEDISCOUNT' | translate }}"
                        name="order_discount"
                        inputId="order_discount"
                        [valueType]="'percent'"
                        [maxValue]="100"
                        [minValue]="0"
                        [(ngModel)]="dataItem.order_discount"
                        (ngModelChange)="setOrderTotal()"
                        [disabled]="datafieldsConfiguration.order_discount.disabled || orderDiscountDisabled || !editMode"
                        #order_discount="ngModel"
                        [error]="order_discount.errors"
                        [showAlternativeStyle]="editMode ? true : false">
                      </phscw-input-number>
                    }
                    @if (datafieldsConfiguration.order_total.visible) {
                      <phscw-input-number
                        [editMode]="editMode"
                        label="{{ 'SHARED.ORDERTRACKING.TOTALSUM' | translate }}"
                        name="order_total"
                        inputId="order_total"
                        [valueType]="'currency'"
                        [currency]="currency"
                        [(ngModel)]="dataItem.order_total"
                        [disabled]="datafieldsConfiguration.order_total.disabled"
                        #order_total="ngModel"
                        [error]="order_total.errors"
                        [showAlternativeStyle]="editMode ? true : false">
                      </phscw-input-number>
                    }
                  </div>
                  <div class="clear"></div>
                  @if (editMode) {
                    <div class="header-margin" class="cw-button-wrapper">
                      <button
                        mat-raised-button
                        color="accent"
                        type="submit"
                        [disabled]="!orderTrackingForm.form.valid || dataItem.delivery_date < dataItem.order_date || 
                        (datafieldsConfiguration.wholesaler_address.required && !dataItem.wholesaler_institution_id)">
                        {{ 'GENERAL.SAVE' | translate }}
                      </button>
                      &nbsp;
                      @if (showSendButton) {
                        <button
                          mat-raised-button
                          color="accent"
                          type="button"
                          (click)="clickSubmit('send')"
                          [disabled]="!orderTrackingForm.form.valid || dataItem.delivery_date < dataItem.order_date">
                          {{ 'GENERAL.SEND' | translate }}
                        </button>
                      }
                      <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
                        {{ 'GENERAL.CANCEL' | translate }}
                      </button>
                    </div>
                  }
                  @if (!editMode) {
                    <div class="header-margin">
                      <!-- Timestamps -->
                      <div class="cw-horizontalline"></div>
                      <phscw-output-timestamp
                        class="cw-flex-row"
                        label="{{ 'GENERAL.CREATION' | translate }}"
                        [timestamp]="dataItem.create_date"
                        additional="{{ dataItem.create_user }}">
                      </phscw-output-timestamp>
                      <phscw-output-timestamp
                        class="cw-flex-row"
                        label="{{ 'GENERAL.ALTERATION' | translate }}"
                        [timestamp]="$any(dataItem.edit_date)"
                        additional="{{ dataItem.edit_user }}">
                      </phscw-output-timestamp>
                    </div>
                  }
                </div>
              }
            </form>

            @if (allowOrderDocumentUpload && !editMode && !(dataItem.id | isUndefined) && dataItem.id > 0) {
              <div
                class="header-margin"
                >
                <phscw-documents
                  id="cw-order-tracking-documents"
                  backendController="Documents"
                  type="orders"
                  [displayGridId]="orderDocumentsDisplayGridId"
                  [entityId]="dataItem.id"
                  [gridDisplayedColumns]="orderDocumentsDisplayedColumns"
                  [allowFileUpload]="allowOrderDocumentUpload">
                  <!-- Modul-Titel -->
                  <h3>{{ 'SHARED.ORDERTRACKING.DOCUMENTS' | translate }}</h3>
                  <div class="cw-horizontalline"></div>
                </phscw-documents>
              </div>
            }
